
import BaseStore from '../base-store'
let options = {}
export default new BaseStore('events', options)



// WEBPACK FOOTER //
// ./src/store/modules/events.store.js